export default "__VITE_ASSET__auB4nmoI__"